const TabPanel = ({ tabs, activeTab, onTabChange }) => (
  <div className="dashboard-tabs" role="tablist">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        role="tab"
        aria-selected={activeTab === tab.id}
        className={activeTab === tab.id ? "active" : ""}
        onClick={() => onTabChange(tab.id)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export default TabPanel;
